import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import AdminLayout from 'app/layout/layout-datta-able/AdminLayout'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { FallbackView } from '../../_metronic/partials'
import { LeftSidebar } from '../layout/layout-blueprints'
import { MeWrapper } from '../pages/me/MeWrapper'
import { useLocation } from 'react-router-dom'

const CreateOrderPage = lazy(() => import('../modules/orders/CreateOrder'))

export function PublicRoutes() {
  const location = useLocation();

  const WidgetsPage = lazy(() => import('../modules/orders/OrdersPage'));

  return (
    <AdminLayout>
      <Suspense fallback={<FallbackView />}>
        <Switch location={location} key={location.pathname}>
          <Route path='/page/subscribeOrders/create' component={(props: any) => <CreateOrderPage {...props} apiAlias="subscribe" />} />
          <Route path='/page/likeOrders/create' component={(props: any) => <CreateOrderPage {...props} apiAlias="like" />} />
          <Route path='/doi-soat' component={MeWrapper} />
          <Route path='/page/subscribeOrders/:state' component={(props: any) => <WidgetsPage {...props} apiAlias="subscribe" />} />
          <Route path='/page/likeOrders/:state' component={(props: any) => <WidgetsPage {...props} apiAlias="like" />} />
          <Redirect from='/auth' to='/page/subscribeOrders/dang-chay' />
          <Redirect exact from='/' to='/page/subscribeOrders/dang-chay' />
          <Redirect to='error/404' />
        </Switch>
      </Suspense>
    </AdminLayout>
  )
}
